import { UserType } from '../user';
import { randomText } from './randomText';
import { addCardToUser, StripeInstanceForTesting } from './addCardToUser';

export const CAW_TEST_SUBSCRIPTION_GB = {
  shortCode: 'climate-action-workforce-gbp',
  addons: [{ quantity: 5, shortCode: 'climate-action-workforce-grow-gbp' }],
} as const;

export type SubscriptionVariant = 'business' | 'caw';

type CreateSubscriptionUserBaseOptions = {
  apiBaseUrl: string;
  headers: Record<string, string>;
  stripe: StripeInstanceForTesting;
};

export async function createSubscriptionUser(
  email: string,
  {
    variant = 'business',
    apiBaseUrl,
    headers,
    stripe,
    employeeTierQuantity = 1,
    numberOfLocalTrees = 1,
  }: CreateSubscriptionUserBaseOptions & {
    variant?: SubscriptionVariant;
    employeeTierQuantity?: number;
    numberOfLocalTrees?: number;
  },
): Promise<UserType> {
  const subscription =
    variant === 'caw'
      ? CAW_TEST_SUBSCRIPTION_GB
      : {
          shortCode: 'business-v3-gbp',
          addons: [
            { quantity: employeeTierQuantity, shortCode: 'tier-1-v3-gbp' },
            { quantity: employeeTierQuantity, shortCode: 'tier-2-v3-gbp' },
            { quantity: employeeTierQuantity, shortCode: 'tier-3-v3-gbp' },
            { quantity: numberOfLocalTrees, shortCode: 'uk-reforestation-project-v3' },
          ],
        };

  const response = await fetch(`${apiBaseUrl}/users/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...headers },
    body: JSON.stringify({
      type: 'business',
      captchaToken: '',
      customer: {
        emailAddress: email,
        firstName: 'Fname-' + randomText(5),
        lastName: 'Lname-' + randomText(5),
        location: 'GB',
      },
      user: {
        groupName: 'Bname-' + randomText(5),
        isMarketingAccepted: false,
        password: 'Pword-' + randomText(5),
      },
      subscription,
    }),
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  const { data } = await response.json();
  const user = data.user;

  await addCardToUser(email, { apiBaseUrl, headers, stripe });

  const label = variant === 'caw' ? 'CAW' : 'Business';
  console.log(`${label} subscription user successfully created: ${email}`);
  return user;
}
